<template>
  <div id="app">
    <el-container>
      <el-header class="div-header">
        <Header />
        <el-divider class="header-divider"></el-divider>
      </el-header>

      <div class="main-div">
        <el-container class="parentDiv">
          <splitpanes class="default-theme defaultStyle custom-splite">
            <pane size="100" class="SideBarLeft">
              <div class="SID1019-001_SearchRegScreen">
                <!-- Breadcrumb section -->
                <section>
                  <el-breadcrumb separator-class="el-icon-arrow-right" class="SearchRegLink">
                    <el-breadcrumb-item :to="{ path: '0002' }">トップ(記事一覧)</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '' }">トピックス作成(初期状態)</el-breadcrumb-item>
                  </el-breadcrumb>
                </section>

                <!-- Info div section -->
                <section class="layoutSectionTop">
                  <el-row class="layoutContainerDiv">
                    <el-form :model="ruleForm" :inline="true" class="create__topics" :rules="rules" ref="ruleForm">
                      <el-form-item >
                        <el-button type="primary" class="buttonInformation">
                          <i class="fas fa-user"></i>
                        </el-button>
                      </el-form-item>
                      <el-form-item label="タイトル" prop="label">
                        <el-select v-model="ruleForm.label" placeholder="選択してください。" @change="handleChange" class="titleColumnSelect">
                          <el-option
                            v-for="item in getDropSelect"
                            
                            :key="item.topics_id"
                            :label="item.topics_name"
                            :value="item.topics_id"
                           
                            ></el-option>
                          </el-select>
                      </el-form-item>
                      <el-form-item label="媒体" prop="label1">
                        <el-select v-model="ruleForm.label1" class="mediumColumnSelection">
                          <el-option  
                           v-for="select in serviceLinkageDropdown"
                            :key="select.value"
															:label="select.label"
															:value="select.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="クリップ日" prop="date">
                        <!-- Change by AJ for backlog Id: 1576  -->
                        <v-date-picker :masks="{ title: 'YYYY年MMM' }" :input-props='{readonly : true}' :popover="{  visibility: 'click' }" v-model="ruleForm.date" locale="ja" @input="resetFunction"/>
                        <!-- Change by AJ for backlog Id: 1576  -->
                      </el-form-item>
                      <el-form-item>
                        <el-button type="danger" @click="Goto_1019_002('ruleForm')" class="topicRegistration">
                        <i class="fas fa-copy"></i> トピックス作成
                      </el-button>
                      </el-form-item>
                    </el-form>
                    <!-- {{getDropSelect}} -->
                    <!-- <el-col class="info__button">
                      <el-button type="primary" class="buttonInformation">
                        <i class="fas fa-user"></i>
                      </el-button>
                    </el-col>
                    <el-col class="ColumnLayoutTop">
                      <div class="titleSelectOption">
                        <div class="grid-label">タイトル</div>
                        <el-select v-model="label" class="titleColumnSelect">
                          <el-option
                            v-for="item in getDropSelect"
                            :key="item.value"
                            :label="item.topics_name"
                            :value="item.topics_id"
                          ></el-option>
                        </el-select>
                      </div>
                    </el-col>
                    <el-col class="ColumnLayoutTop">
                      <div class="titleSelectOption">
                        <div class="grid-label">媒体</div>

                        <el-select v-model="label" class="mediumColumnSelection">
                          <el-option label="選択" value="選択"></el-option>
                        </el-select>
                      </div>
                    </el-col>
                    <el-col class="ColumnLayoutTop">
                      <div class="titleSelectOption">
                        <div class="grid-label">クリップ日</div>

                        <v-date-picker :masks="{ title: 'YYYY年MMM' }" v-model="date" locale="ja" />
                      </div>
                    </el-col>
                    <el-col class="topic__creation">
                      <el-button type="danger" @click="gotoanother" class="topicRegistration">
                        <i class="fas fa-copy"></i> トピック作成
                      </el-button>
                    </el-col> -->
                  </el-row>
                </section>

                <!-- Test===============cacnafnmbmvdmbncvahvsc,hmavcbvbncvca -->
                <!-- <section class="layoutSectionTop">
                  <el-row class="layoutContainerDiv" :gutter="10">
                    <el-col>
                      <el-form>
                        <el-form-item>
                          <el-button type="primary" class="buttonInformation">
                            <i class="fas fa-user"></i> information
                          </el-button>
                        </el-form-item>
                      </el-form>
                    </el-col>
                    <el-col>
                      <el-form>
                        <el-form-item label="タイトル">
                          <el-select v-model="label" class="titleColumnSelect">
                            <el-option label="選択" value="選択"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-form>
                    </el-col>
                    <el-col>
                      <el-form>
                        <el-form-item label="媒体">
                          <el-select v-model="label" class="mediumColumnSelection">
                            <el-option label="選択" value="選択"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-form>
                    </el-col>
                    <el-col>
                      <el-form>
                        <el-form-item label="クリップ日">
                          <v-date-picker v-model="date" locale="ja" />
                        </el-form-item>
                      </el-form>
                    </el-col>
                    <el-col>
                      <el-form>
                        <el-form-item>
                          <el-button type="danger" @click="gotoanother" class="topicRegistration">
                            <i class="fas fa-copy"></i> トピック作成
                          </el-button>
                        </el-form-item>
                      </el-form>
                    </el-col>
                  </el-row>
                </section>-->

                <!-- Topic registration information section -->
                <section class="AriticleInformation">
                  <span>選択したタイトル、媒体、クリップ日付でトピックスを作成します。</span>
                  <span>プルダウンを選択し、「トピックス作成」ボタンを押してください。</span>
                </section>
              </div>
            </pane>
            <pane class="SideBarRight">
              <SideBar class="SidePane" />
            </pane>
          </splitpanes>
        </el-container>
      </div>

      <el-container class="footer-div">
        <el-footer class="footer-element">
          <FooterComponent />
        </el-footer>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Header from "../common/header.vue";
import SideBar from "../common/side-bar.vue";
import FooterComponent from "../common/footerComponent.vue";
import { mapGetters } from "vuex";
import router from "../../router";
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
export default {
  name: "SearchConditionRegScreen",
  components: {
    Header,
    SideBar,
    FooterComponent,
    Splitpanes,
    Pane
  },
  data() {
    return {
      ruleForm:{
      label: "",
      label1: "",
      date: new Date(),
      },
      serviceLinkageDropdown:[],
      topics_id:'',
      
      rules: {
          label: [
            { required: true, message: 'タイトルを入力してください。', trigger: 'change' },
          ],
          date:[
            { required: true, message: '日付を入力してください。', trigger: 'change' },
          ],
          label1:[
            { required: true, message: '', trigger: 'change' },
          ]
        },
      resetDateValue: new Date()
    };
  },
  computed: {
    ...mapGetters("situation1019001", ["getDropSelect",""]),
    ...mapGetters("situation0001", [

      "getUserId",
      "getNews_Article_Flag",
      "getMagazine_Article_Flag",
      "getWeb_News_Article_Flag",
      "getCompanyConfigurationInfo"
    ])
  },
  methods: {
    Goto_1019_002(formName) {
      this.$LogButtonEvent("1019-001","CreateTopic");
      this.$LogMethodIN("1019-001","Goto_1019_002");
       this.$refs[formName].validate((valid) => {
          if (valid) {
            /*
              worked: BM
              Date: 2020-09-18
              comments: Display request upper limit display on SID1019-002
              
            */
           var company_configuration_info = this.getCompanyConfigurationInfo; 
            for(var s=0;s<company_configuration_info.length;s++)
            {
              if(company_configuration_info[s].configuration_key == "DISPLAY_COLLECTIVE_DEMAND_MAX_COUNT")
              {
                var DIS_COLLECTIVE_DEMAND_MAX_COUNT = company_configuration_info[s].configuration_value;
              }
              /*** Change by SJ for backlog Id: 1560 */
              //For the condition DISPLAY_COLLECTIVE_DEMAND_MAX_COUNT equal to 0 Means text is NOT displayed. 
              //For the condition COLLECTIVE_DEMAND_MAX_COUNT NOT equal to 0 Means text is displayed.
              
              if(DIS_COLLECTIVE_DEMAND_MAX_COUNT == 0){

                this.$store.commit('situation1019002/collective_demand_max_count','');

              }
              else if(company_configuration_info[s].configuration_key == "COLLECTIVE_DEMAND_MAX_COUNT")
              {
                 var Coll_Demand_Max_Count= "トピックスメールからの原文直接表示の上限は"+company_configuration_info[s].configuration_value+"件です。";
                this.$store.commit('situation1019002/collective_demand_max_count',Coll_Demand_Max_Count);
                

              }
              else{
                // no needed action
              }
            }
              
            var dateFormatCheck=this.ruleForm.date;
            var splitDataFormat = new Date(dateFormatCheck),
            splitmonthFormat = ("0" + (splitDataFormat.getMonth() + 1)).slice(-2),
            splitdayFormat = ("0" + splitDataFormat.getDate()).slice(-2);
            var newDateFormat = [splitDataFormat.getFullYear(), splitmonthFormat, splitdayFormat].join("/");

            
            //For sending the title name
            var TitletoShow=this.ruleForm.label;
            var nextpageTitle=this.getDropSelect.length;
            var assign=[];
            var titleName='';
            var display_order=[];
            
            //looping for title 
            for(var i = 0; i < nextpageTitle; i++){
            
              assign.push(this.getDropSelect[i].topics_id);
              display_order.push(this.getDropSelect[i].display_order);

            }

           //For taking the index of selected title
            var assignIndex= assign.indexOf(TitletoShow)
          
            //assigning to a variable
    
            titleName = this.getDropSelect[assignIndex].topics_name;
            var media = "新聞";
            if(this.ruleForm.label1 == 1 || this.ruleForm.label1 == "新聞"){
                media = "新聞";
            }

            if(this.ruleForm.label1 == 5 || this.ruleForm.label1 == "雑誌"){
                media = "雑誌";
            }

            if(this.ruleForm.label1 == 2 || this.ruleForm.label1 == "WEB"){
                media = "WEB";
            }

            var secondScreen={
              displayOrder:display_order,
              title:titleName,
              topics_id:this.topics_id,
              media:media,
              date:newDateFormat
            }
                         
 

            router.push({
              name: "1019-002",
              params: {
                secondScreen: secondScreen,
              }
            });
           
          } else {
            return false;
          }
        });
       this.$LogMethodOut("1019-001","Goto_1019_002"); 
    },
    handleChange(index){
      this.$LogButtonEvent("1019-001","ChangeTopic");
      this.$LogMethodIN("1019-001","handleChange");
      this.topics_id = index;
      this.$LogMethodOut("1019-001","handleChange"); 
    },
    /*** Change by AJ for backlog Id: 1576 */
    resetFunction(){

      //Code for set the selected date when double click the calender
      if(this.ruleForm.date != null)
      {
        this.resetDateValue = this.ruleForm.date;
      }
      else
      {
        this.ruleForm.date = new Date(this.resetDateValue);
      }
    },
    /*** Change by AJ for backlog Id: 1576 */
     
  },
  beforeCreate() {
    //Common.Session.CheckSessionExists_IfExpired_GoToLogout();
  },
  
  mounted() {
    var setFirstTableEmpty = [];
      this.$store.commit('situation1019002/getFirstTable', setFirstTableEmpty); 
      this.$store.commit('situation1019002/getArticleCount',0);
          
    var tableData = {
      user_id:this.getUserId   
    }
    this.$store.dispatch("communication1019001/gettitle", tableData).then(() =>{
      
      this.getDropSelect.sort(function(a,b){                
        
        return a.display_order - b.display_order
      });
      this.ruleForm.label = this.getDropSelect[0].topics_id;
      this.topics_id = this.getDropSelect[0].topics_id;
    });
    var newsSession=this.getNews_Article_Flag
    var magazineSession=this.getMagazine_Article_Flag
    var webSession=this.getWeb_News_Article_Flag
    
    if(newsSession == true){
      var innerLoopServicenews = {};
      innerLoopServicenews.label="新聞";
      innerLoopServicenews.value="1";
      this.serviceLinkageDropdown.push(innerLoopServicenews);
      this.ruleForm.label1="新聞"
    }
    if(magazineSession == true){
      var innerLoopServiceMagazine = {};
      innerLoopServiceMagazine.label="雑誌";
      innerLoopServiceMagazine.value="5";
      this.serviceLinkageDropdown.push(innerLoopServiceMagazine);
      if(newsSession == false){
        this.ruleForm.label1="雑誌"
      }
    }  
    if(webSession == true){
      var innerLoopServiceWeb = {};
      innerLoopServiceWeb.label="WEB";
      innerLoopServiceWeb.value="2";
      this.serviceLinkageDropdown.push(innerLoopServiceWeb);
      if(newsSession == false && magazineSession == false){
        this.ruleForm.label1="WEB"
      }
    }  
  },
  created(){
    //For the screen Title
     document.title = "トピックス作成画面";
    
  }
};
</script>

<style scoped>
@import "1019-001.css";
</style>